import { gql } from '@apollo/client';

export const ADD_RELEASE = gql`
  mutation createRelease($input: CreateReleaseInput!) {
    createRelease(input: $input) {
      message
    }
  }
`;

export const EDIT_RELEASE = gql`
  mutation updateRelease($id: ID!, $input: UpdateReleaseInput!) {
    updateRelease(id: $id, input: $input) {
      message
    }
  }
`;
